import type {AnalyticsInstance, AnalyticsPlugin} from 'analytics';
import Analytics from 'analytics';

import contextExtractor from './plugins/contextExtractor';
import rudderstackEvents from './plugins/rudderstackEvents';
import type {AnalyticsContext, RudderstackConfig, ServiceConfig} from './shared/types';

export interface EzcaterAnalyticsConfig {
  service: ServiceConfig;
  rudderstack: RudderstackConfig;
}

export function createEzcaterAnalytics(
  config: EzcaterAnalyticsConfig,
  getContext?: () => AnalyticsContext | undefined,
): AnalyticsInstance {
  const {rudderstack: rudderstackConfig} = config;
  const plugins: AnalyticsPlugin[] = [
    contextExtractor({service: config.service}, getContext ?? (() => undefined)),
    rudderstackEvents(rudderstackConfig),
  ];

  return Analytics({app: 'ezcater', plugins});
}
